const exportable = {
    babel: {
        // "babel": "^6.23.0",
        // "babel-cli": "^6.26.0",
        // "babel-core": "^6.26.0",
        // "babel-eslint": "^8.0.2",
        
        "babel-plugin-add-module-exports": "^0.2.1",
        "babel-plugin-react-css-modules": "^3.3.2",
        "babel-plugin-syntax-dynamic-import": "^6.18.0",
        "babel-plugin-transform-async-to-generator": "^6.24.1",
        "babel-plugin-transform-decorators-legacy": "^1.3.4",
        
        "babel-plugin-transform-regenerator": "^6.26.0",
        "babel-plugin-transform-runtime": "^6.23.0",
        "babel-plugin-transform-es2015-classes": "^6.24.1",
        "babel-plugin-transform-es2015-modules-umd": "^6.24.1",

        "babel-preset-env": "^1.6.1",
        "babel-preset-es2015": "^6.24.1",
        "babel-preset-es2015-webpack": "^6.4.3",
        "babel-preset-preact": "^1.1.0",
        "babel-preset-react": "^6.24.1"
    },
    client: {
        "postcss": "^6.0.13",
        "postcss-cssnext": "^3.0.2",
        "postcss-loader": "^2.0.8",
        "critical": "^1.0.0",
        "css-loader": "^0.28.7",

        "babel-plugin-transform-react-jsx": "^6.24.1",

        "style-loader": "^0.19.0",
        "stylelint": "^8.4.0",
        "stylelint-webpack-plugin": "^0.9.0",
        "extract-loader": "^1.0.1",
        "extract-text-webpack-plugin": "^3.0.1",
        "html-loader": "^0.5.1",
        "html-webpack-exclude-assets-plugin": "0.0.5",
        // "html-webpack-harddisk-plugin": "^0.1.0",
        "html-webpack-include-assets-plugin": "^1.0.2",
        "html-webpack-plugin": "^2.30.1",
        "resolve-url-loader": "^2.2.1",
        // "url-loader": "^0.6.2",
        "webpack-hot-middleware": "^2.20.0",
        "htmllint-loader": "^2.1.4",
        "reset-css": "^2.2.1",
        "favicons-webpack-plugin": "0.0.7",
        // "webpack-plugin-critical": "^1.0.0",
        "webpack-spritesmith": "^0.3.3",
        "wrapper-webpack-plugin": "^1.0.0",
    },
    server: {
        "express": "^4.16.2",
        "concurrently": "^3.5.0",
        "http-server": "^0.10.0",
        "dev-server": "0.0.2",
        "html-webpack-harddisk-plugin": "^0.1.0",
        "webpack-dev-middleware": "^1.12.0",
        "webpack-hot-middleware": "^2.20.0"
    },
    developer: {
        "parker": "^0.0.10",
        "nsp": "^3.1.0"
    },
    imageOptimization: {
        "imagemin-mozjpeg": "^6.0.0",
        "imagemin-pngcrush": "^5.1.0",
        "imagemin-webp": "^4.0.0",
        "imagemin-webpack-plugin": "^1.5.2"
    },
    react: {
        "react": "^16.0.0",
        "react-addons-css-transition-group": "^15.6.2",
        "react-dom": "^16.0.0",
        "react-loader": "^2.4.2",
        "reload-html-webpack-plugin": "^0.1.2",
        "preact": "^8.2.5",
        "preact-compat": "^3.17.0",
        "preact-render-to-string": "^3.7.0",
        "preact-router": "^2.5.7"
    },
    coffee: {
        "coffee-loader": "^0.8.0",
        "coffeescript": "^2.0.2"
    },
    typescript: {
        "typescript": "^2.5.3",
        "ts-loader": "^3.1.1"
    },
    vue: {
        "vue": "^2.5.2",
        "vue-html-loader": "^1.2.4",
        "vue-loader": "^13.5.0",
        "vue-style-loader": "^3.0.3",
        "vue-template-compiler": "^2.5.2"
    },
    stylus: {
        "stylus": "^0.54.5",
        "stylus-loader": "^3.0.1"
    },
    sass: {
        "node-sass": "^4.5.3",
        "sass-loader": "^6.0.6"
    },
    less: {
        "less": "^3.0.0-alpha.3",
        "less-loader": "^4.0.5"
    },
    ejs: {
        "ejs-loader": "^0.3.0"
    },
    json: {
        "json5-loader": "^1.0.1"
    }
}

Object.defineProperty(exportable, 'dependencyExts', {
    value: {
        '.styl': 'stylus',
        '.scss': 'sass',
        '.sass': 'sass',
        '.less': 'less',
        '.json': 'json',
        '.vue': 'vue',
        '.ts': 'typescript',
        '.tsx': 'typescript',
        '.coffee': 'coffee',
        '.jsx': 'react',
        '.png': 'imageOptimization',
        '.jpg': 'imageOptimization',
        '.jpeg': 'imageOptimization',
        '.gif': 'imageOptimization',
        '.webp': 'imageOptimization',
    },
    writable: false,
    enumerable: false
});

module.exports = exportable



// WEBPACK FOOTER //
// ./src/technologies/deps.js